var _path, _path2, _g, _g2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCertPurpleShield(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 199,
    height: 230,
    viewBox: "0 0 199 230",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M97.3215 34.9739V10.2712C80.6101 6.63833 22.4855 21.896 12.3148 42.9663C-0.764543 138.146 35.5636 196.998 95.8688 211.529V178.833C21.759 175.201 -7.30399 53.8645 97.3215 34.9739Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M102.406 34.9717V9.33218C119.117 5.69928 175.789 21.6837 185.96 42.7541C203.399 138.144 162.711 197.722 102.406 212.253V178.621C176.516 174.988 207.031 53.8622 102.406 34.9717Z",
    fill: "white"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_5725_9485)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M99.5 3C37.934 3 8.51156 37.3824 7.28533 38.8471C6.77884 39.4607 6.50152 40.2281 6.5 41.0202L6.5 109.513C6.5 167.445 60.4124 201.842 83.5867 213.94C84.3892 214.308 85.3038 214.357 86.1417 214.077C86.9796 213.797 87.6769 213.21 88.0896 212.436C88.5024 211.663 88.5991 210.762 88.3598 209.92C88.1206 209.078 87.5636 208.359 86.8038 207.911C59.386 193.598 13.3889 161.784 13.3889 109.506V42.3146C18.2249 37.1712 45.2982 10.9978 96.0556 9.85331V217.592C96.0552 218.284 96.2679 218.96 96.6656 219.529C97.0632 220.099 97.6268 220.535 98.2813 220.78C98.9358 221.025 99.6503 221.066 100.329 220.9C101.009 220.733 101.62 220.366 102.083 219.847C113.36 215.051 192.5 178.87 192.5 108.593V40.4684C192.5 39.6749 192.22 38.9063 191.708 38.2953C190.688 37.0758 166.122 8.49083 114.959 3.38831C114.052 3.30786 113.149 3.5814 112.444 4.15045C111.738 4.71951 111.286 5.53891 111.184 6.43347C111.138 6.87855 111.181 7.32819 111.311 7.75669C111.441 8.1852 111.655 8.58418 111.941 8.93085C112.227 9.27752 112.579 9.5651 112.978 9.77714C113.376 9.98919 113.813 10.1216 114.263 10.1667C157.573 14.4858 181.106 37.0418 185.611 41.7764V108.593C185.611 169.578 121.11 203.62 102.944 211.999V6.40622C102.944 5.50283 102.582 4.63645 101.936 3.99766C101.29 3.35887 100.414 3 99.5 3Z",
    fill: "#151515"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_5725_9485)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 100,
    cy: 106.5,
    r: 72.5,
    fill: "#9E007E"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_5725_9485",
    x: 0.5,
    y: 0,
    width: 198,
    height: 230,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 3
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_5725_9485"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_5725_9485",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_5725_9485",
    x: 21.5,
    y: 31,
    width: 157,
    height: 157,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 3
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_5725_9485"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_5725_9485",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCertPurpleShield);
export default __webpack_public_path__ + "static/media/cert-purple-shield.c3e025e04ea590f93e7ffe99eff58c4a.svg";
export { ForwardRef as ReactComponent };